// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Card Component */
.ids-card {
  background-color: var(--ids-card-color-background);
  border: 1px solid var(--ids-card-color-border);
  border-radius: var(--ids-card-border-radius);
  box-shadow: var(--ids-card-shadow);
  margin-block-end: var(--ids-card-margin-bottom);
  height: max-content;
  position: relative;
  width: var(--ids-card-width);
}
.ids-card .ids-card-content {
  height: var(--ids-card-content-height);
  overflow: auto;
  width: 100%;
  overflow-x: hidden;
  position: relative;
}
.ids-card .ids-card-content.overflow-hidden {
  overflow: hidden;
}
.ids-card .ids-card-content.has-data-grid {
  overflow: hidden;
}
.ids-card .ids-card-content.has-data-grid ::slotted([slot=card-content]) {
  height: calc(100% + 3px);
  display: block;
}
.ids-card.shadowed {
  border: 1px solid transparent;
}
.ids-card-checkbox {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  bottom: 0;
  width: 50px;
  align-items: center;
  justify-content: center;
}
.ids-card.is-selectable {
  cursor: var(--ids-cursor-pointer);
}
.ids-card.is-selected {
  background-color: var(--ids-card-color-background-selected);
  outline: 2px solid var(--ids-card-color-border-selected);
  outline-offset: -1px;
}
.ids-card .hidden {
  display: none;
}

.ids-card-header {
  align-items: center;
  color: var(--ids-card-header-title-color);
  display: flex;
  padding-inline-start: var(--ids-card-header-padding-inline-start);
  padding-inline-end: var(--ids-card-header-padding-inline-start);
  height: var(--ids-card-header-height);
}

.ids-card-subheader {
  align-items: flex-start;
  color: var(--ids-card-header-title-color);
  display: flex;
  flex-direction: column;
  height: auto;
  padding-inline-start: var(--ids-card-header-padding-inline-start);
  padding-inline-end: var(--ids-card-header-padding-inline-start);
}

::slotted([slot=card-header]) {
  display: block;
  align-items: center;
  position: relative;
  width: 100%;
}

::slotted([slot=card-subheader]) {
  display: flex;
  align-items: center;
  padding-block-end: var(--ids-card-subheader-padding-block-end);
  position: relative;
  width: 100%;
}

::slotted([slot=card-subheader]:first-child) {
  padding-block-start: 0;
}

:host([no-header]) .ids-card-header {
  display: none;
}

:host([shadowed]) .ids-card {
  border: 1px solid var(--ids-box-shadowed-color-border);
  overflow-x: hidden;
}

.ids-card-footer {
  padding: 3px 0;
  display: none;
  bottom: 0;
  border-top: 1px solid var(--ids-card-divider-color-border);
  min-height: var(--ids-card-footer-height);
  overflow: hidden;
  width: 100%;
}
.ids-card-footer.no-padding {
  padding: 0;
}

.has-footer .ids-card-content {
  height: 260px;
}
.has-footer .ids-card-footer {
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  overflow-x: hidden;
}

:host([auto-fit]) .ids-card {
  box-sizing: border-box;
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  min-height: auto;
}
:host([auto-fit]) .ids-card .ids-card-content {
  height: unset;
}

:host([auto-height]) .ids-card {
  min-height: auto;
  height: auto;
}
:host([auto-height]) .ids-card .ids-card-content {
  height: auto;
}
:host([auto-height]) .ids-card ids-button,
:host([auto-height]) .ids-card ids-hyperlink {
  height: auto;
}
:host([auto-height]) .ids-card ids-button::part(button),
:host([auto-height]) .ids-card ids-hyperlink::part(link) {
  height: auto;
}

:host([borderless]) .ids-card {
  border-color: var(--ids-color-transparent);
  box-shadow: none;
}
:host([borderless]) .ids-card:hover {
  border-color: transparent;
}

:host([actionable]) ids-hyperlink {
  height: 50px;
}
:host([actionable]) ids-hyperlink::part(link) {
  box-sizing: border-box;
  border: none;
  color: var(--ids-card-color-text-default);
  display: flex;
  margin: 0;
  padding: 0;
  text-align: center;
  text-decoration: none;
  width: 100%;
  white-space: normal;
}
:host([actionable]) ids-hyperlink::part(link):hover {
  color: var(--ids-card-color-text-hover);
}

:host .flex-content,
:host ::slotted(.flex-content) {
  display: flex;
  align-items: center;
  padding: 15px var(--ids-space-sm);
  gap: var(--ids-space-sm);
}

:host([actionable]) .ids-card {
  contain: unset;
  height: auto;
  transition: var(--ids-motion-duration) var(--ids-motion-ease);
}
:host([actionable]) .ids-card:hover {
  border: 1px solid var(--ids-card-color-border-hover);
}
:host([actionable]) .ids-card:not(.hide-focus):focus-within {
  border: 1px solid var(--ids-card-color-border-focus);
  box-shadow: var(--ids-shadow-30);
}
:host([actionable]) .ids-card ::slotted([slot=card-content]) {
  pointer-events: none;
  width: 100%;
}
:host([actionable]) .ids-card ids-button {
  align-items: center;
  height: 50px;
  width: 100%;
}
:host([actionable]) .ids-card ids-hyperlink::part(link),
:host([actionable]) .ids-card ids-button::part(button) {
  align-items: center;
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  height: 50px;
}
:host([actionable]) .ids-card ids-hyperlink::part(link):hover,
:host([actionable]) .ids-card ids-button::part(button):hover {
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-tertiary-color-text-default);
}

.ids-card-body {
  width: 100%;
  overflow-x: hidden;
}
.ids-card-body.has-checkbox {
  padding-inline-start: 50px;
  width: calc(100% - 50px);
}

::slotted([slot=card-content].fixed-height) {
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: inherit;
  justify-content: center;
  padding: 0 var(--ids-space-xs);
  text-align: center;
  width: 100%;
}

:host([draggable]) {
  width: var(--ids-card-width);
  z-index: 1;
  transition: var(--ids-motion-duration) var(--ids-motion-ease);
}
:host([draggable]) .ids-card {
  border: 1px solid var(--ids-card-color-border-draggable);
  box-shadow: none;
  height: auto;
  min-height: auto;
  cursor: move;
  overflow-x: hidden;
}
:host([draggable]) .ids-card .ids-card-header {
  min-height: 56px;
}
:host([draggable]) .ids-card .ids-card-header slot[name=card-header] {
  display: flex;
  align-items: center;
  gap: 20px;
}
:host([draggable]) .ids-card:hover {
  background-color: var(--ids-card-color-background-hover);
  color: var(--ids-card-color-text-hover);
}
:host([draggable]) .ids-card:hover .ids-card-header slot[name=card-header] {
  color: var(--ids-card-color-text-hover);
}
:host([draggable]) .ids-card.is-overlapping {
  cursor: no-drop;
}
:host([draggable]) .ids-card.is-dropped {
  z-index: 99;
  width: var(--ids-card-width-dropped, var(--ids-card-width));
  height: var(--ids-card-height-dropped, "auto");
  background-color: var(--ids-card-color-background-dropped, #F5F5F5);
  opacity: 0.8;
}
:host([draggable]) .ids-card.is-dropped .ids-card-header slot[name=card-header] {
  color: var(--ids-card-color-text-default);
}
:host([draggable]) .ids-card.is-dragging {
  z-index: 999;
  width: var(--ids-card-width-dragged, var(--ids-card-width));
  height: var(--ids-card-height-dragged, "auto");
  background-color: var(--ids-card-color-background-dragged, #F5F5F5);
  opacity: 0.8;
}
:host([draggable]) .ids-card.is-dragging .ids-card-header slot[name=card-header] {
  color: var(--ids-card-color-text-default);
}
:host([draggable]) .ids-card.is-fixed.is-dropped, :host([draggable]) .ids-card.is-fixed.is-dragging {
  position: absolute;
  justify-content: center;
}
:host([draggable]) .ids-card.is-fixed.is-dropped .ids-card-header, :host([draggable]) .ids-card.is-fixed.is-dragging .ids-card-header {
  justify-content: center;
  align-items: center;
}

:host([draggable][is-dragging]) {
  z-index: 99;
  transition: none;
}

:host([draggable][dropped]) {
  z-index: 9;
  transition: none;
}

:host([disabled]) .ids-card {
  pointer-events: none;
  opacity: 0.5;
}

:host([actionable][height]) .ids-card ids-hyperlink {
  height: inherit;
}
:host([actionable][height]) .ids-card ids-hyperlink::part(link) {
  height: inherit;
}
:host([actionable][height]) .ids-card ids-button {
  height: inherit;
}
:host([actionable][height]) .ids-card ids-button::part(button) {
  height: inherit;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-card/ids-card.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA;EACE,kDAAA;EACA,8CAAA;EACA,4CAAA;EACA,kCAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;AAAF;AAEE;EACE,sCAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;AAEI;EACE,gBAAA;AAAN;AAGI;EACE,gBAAA;AADN;AAGM;EACE,wBAAA;EACA,cAAA;AADR;AAME;EACE,6BAAA;AAJJ;AAOE;EACE,kBAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AALJ;AAQE;EACE,iCAAA;AANJ;AASE;EACE,2DAAA;EACA,wDAAA;EACA,oBAAA;AAPJ;AAUE;EACE,aAAA;AARJ;;AAaA;EACE,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,iEAAA;EACA,+DAAA;EACA,qCAAA;AAVF;;AAaA;EACE,uBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iEAAA;EACA,+DAAA;AAVF;;AAaA;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,kBAAA;EACA,WAAA;AAVF;;AAaA;EACE,sBAAA;AAVF;;AAcE;EACE,aAAA;AAXJ;;AAgBE;EACE,sDAAA;EACA,kBAAA;AAbJ;;AAkBA;EACE,cAAA;EACA,aAAA;EACA,SAAA;EACA,0DAAA;EACA,yCAAA;EACA,gBAAA;EACA,WAAA;AAfF;AAiBE;EACE,UAAA;AAfJ;;AAoBE;EACE,aAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;AAlBJ;;AAwBE;EACE,sBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AArBJ;AAuBI;EACE,aAAA;AArBN;;AA4BE;EACE,gBAAA;EACA,YAAA;AAzBJ;AA2BI;EACE,YAAA;AAzBN;AA4BI;;EAEE,YAAA;AA1BN;AA6BI;;EAEE,YAAA;AA3BN;;AAiCE;EACE,0CAAA;EACA,gBAAA;AA9BJ;AAgCI;EACE,yBAAA;AA9BN;;AAoCA;EACE,YAAA;AAjCF;AAmCE;EACE,sBAAA;EACA,YAAA;EACA,yCAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;AAjCJ;AAmCI;EACE,uCAAA;AAjCN;;AAuCE;;EAEE,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,wBAAA;AApCJ;;AAyCA;EACE,cAAA;EACA,YAAA;EACA,6DAAA;AAtCF;AAwCE;EACE,oDAAA;AAtCJ;AAyCE;EACE,oDAAA;EACA,gCAAA;AAvCJ;AA0CE;EACE,oBAAA;EACA,WAAA;AAxCJ;AA2CE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AAzCJ;AA4CE;;EAEE,mBAAA;EACA,6BAAA;EACA,8CAAA;EACA,YAAA;AA1CJ;AA4CI;;EACE,8CAAA;EACA,oDAAA;AAzCN;;AA+CA;EACE,WAAA;EACA,kBAAA;AA5CF;AA8CE;EACE,0BAAA;EACA,wBAAA;AA5CJ;;AAgDA;EACE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;AA7CF;;AAgDA;EACE,4BAAA;EACA,UAAA;EACA,6DAAA;AA7CF;AA+CE;EACE,wDAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AA7CJ;AA+CI;EACE,gBAAA;AA7CN;AA+CM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA7CR;AAiDI;EACE,wDAAA;EACA,uCAAA;AA/CN;AAkDQ;EACE,uCAAA;AAhDV;AAqDI;EACE,eAAA;AAnDN;AAsDI;EACE,WAAA;EACA,2DAAA;EACA,8CAAA;EACA,mEAAA;EACA,YAAA;AApDN;AAuDQ;EACE,yCAAA;AArDV;AA0DI;EACE,YAAA;EACA,2DAAA;EACA,8CAAA;EACA,mEAAA;EACA,YAAA;AAxDN;AA2DQ;EACE,yCAAA;AAzDV;AA+DM;EACE,kBAAA;EACA,uBAAA;AA7DR;AA+DQ;EACE,uBAAA;EACA,mBAAA;AA7DV;;AAoEA;EACE,WAAA;EACA,gBAAA;AAjEF;;AAoEA;EACE,UAAA;EACA,gBAAA;AAjEF;;AAqEE;EACE,oBAAA;EACA,YAAA;AAlEJ;;AAuEE;EACE,eAAA;AApEJ;AAuEE;EACE,eAAA;AArEJ;AAwEE;EACE,eAAA;AAtEJ;AAyEE;EACE,eAAA;AAvEJ","sourcesContent":["/* Ids Card Component */\n \n.ids-card {\n  background-color: var(--ids-card-color-background);\n  border: 1px solid var(--ids-card-color-border);\n  border-radius: var(--ids-card-border-radius);\n  box-shadow: var(--ids-card-shadow);\n  margin-block-end: var(--ids-card-margin-bottom);\n  height: max-content;\n  position: relative;\n  width: var(--ids-card-width);\n \n  .ids-card-content {\n    height: var(--ids-card-content-height);\n    overflow: auto;\n    width: 100%;\n    overflow-x: hidden;\n    position: relative;\n \n    &.overflow-hidden {\n      overflow: hidden;\n    }\n \n    &.has-data-grid {\n      overflow: hidden;\n \n      ::slotted([slot=\"card-content\"]) {\n        height: calc(100% + 3px);\n        display: block;\n      }\n    }\n  }\n \n  &.shadowed {\n    border: 1px solid transparent;\n  }\n \n  &-checkbox {\n    position: absolute;\n    display: flex;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 50px;\n    align-items: center;\n    justify-content: center;\n  }\n \n  &.is-selectable {\n    cursor: var(--ids-cursor-pointer);\n  }\n \n  &.is-selected {\n    background-color: var(--ids-card-color-background-selected);\n    outline: 2px solid var(--ids-card-color-border-selected);\n    outline-offset: -1px;\n  }\n \n  .hidden {\n    display: none;\n  }\n}\n \n// Header Area\n.ids-card-header {\n  align-items: center;\n  color: var(--ids-card-header-title-color);\n  display: flex;\n  padding-inline-start: var(--ids-card-header-padding-inline-start);\n  padding-inline-end: var(--ids-card-header-padding-inline-start);\n  height: var(--ids-card-header-height);\n}\n \n.ids-card-subheader {\n  align-items: flex-start;\n  color: var(--ids-card-header-title-color);\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  padding-inline-start: var(--ids-card-header-padding-inline-start);\n  padding-inline-end: var(--ids-card-header-padding-inline-start);\n}\n \n::slotted([slot='card-header']) {\n  display: block;\n  align-items: center;\n  position: relative;\n  width: 100%;\n}\n \n::slotted([slot='card-subheader']) {\n  display: flex;\n  align-items: center;\n  padding-block-end: var(--ids-card-subheader-padding-block-end);\n  position: relative;\n  width: 100%;\n}\n \n::slotted([slot='card-subheader']:first-child) {\n  padding-block-start: 0;\n}\n \n:host([no-header]) {\n  .ids-card-header {\n    display: none;\n  }\n}\n \n:host([shadowed]) {\n  .ids-card {\n    border: 1px solid var(--ids-box-shadowed-color-border);\n    overflow-x: hidden;\n  }\n}\n \n// Footer Area\n.ids-card-footer {\n  padding: 3px 0;\n  display: none;\n  bottom: 0;\n  border-top: 1px solid var(--ids-card-divider-color-border);\n  min-height: var(--ids-card-footer-height);\n  overflow: hidden;\n  width: 100%;\n \n  &.no-padding {\n    padding: 0;\n  }\n}\n \n.has-footer {\n  .ids-card-content {\n    height: 260px;\n  }\n \n  .ids-card-footer {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    overflow-x: hidden;\n  }\n}\n \n// Adjust the width/height to parent fit\n:host([auto-fit]) {\n  .ids-card {\n    box-sizing: border-box;\n    height: 100%;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    min-height: auto;\n \n    .ids-card-content {\n      height: unset;\n    }\n  }\n}\n \n// Adjust the heights with settings\n:host([auto-height]) {\n  .ids-card {\n    min-height: auto;\n    height: auto;\n \n    .ids-card-content {\n      height: auto;\n    }\n \n    ids-button,\n    ids-hyperlink {\n      height: auto;\n    }\n \n    ids-button::part(button),\n    ids-hyperlink::part(link) {\n      height: auto;\n    }\n  }\n}\n \n:host([borderless]) {\n  .ids-card {\n    border-color: var(--ids-color-transparent);\n    box-shadow: none;\n \n    &:hover {\n      border-color: transparent;\n    }\n  }\n}\n \n// Actionable Link Card Styles\n:host([actionable]) ids-hyperlink {\n  height: 50px;\n \n  &::part(link) {\n    box-sizing: border-box;\n    border: none;\n    color: var(--ids-card-color-text-default);\n    display: flex;\n    margin: 0;\n    padding: 0;\n    text-align: center;\n    text-decoration: none;\n    width: 100%;\n    white-space: normal;\n \n    &:hover {\n      color: var(--ids-card-color-text-hover);\n    }\n  }\n}\n \n:host {\n  .flex-content,\n  ::slotted(.flex-content) {\n    display: flex;\n    align-items: center;\n    padding: 15px var(--ids-space-sm);\n    gap: var(--ids-space-sm);\n  }\n}\n \n// Handle Actionable\n:host([actionable]) .ids-card {\n  contain: unset;\n  height: auto;\n  transition: var(--ids-motion-duration) var(--ids-motion-ease);\n \n  &:hover {\n    border: 1px solid var(--ids-card-color-border-hover);\n  }\n \n  &:not(.hide-focus):focus-within {\n    border: 1px solid var(--ids-card-color-border-focus);\n    box-shadow: var(--ids-shadow-30);\n  }\n \n  ::slotted([slot='card-content']) {\n    pointer-events: none;\n    width: 100%;\n  }\n \n  ids-button {\n    align-items: center;\n    height: 50px;\n    width: 100%;\n  }\n \n  ids-hyperlink::part(link),\n  ids-button::part(button) {\n    align-items: center;\n    border: 1px solid transparent;\n    background-color: var(--ids-color-transparent);\n    height: 50px;\n \n    &:hover {\n      background-color: var(--ids-color-transparent);\n      color: var(--ids-button-tertiary-color-text-default);\n    }\n  }\n}\n \n// Style the title\n.ids-card-body {\n  width: 100%;\n  overflow-x: hidden;\n \n  &.has-checkbox {\n    padding-inline-start: 50px;\n    width: calc(100% - 50px);\n  }\n}\n \n::slotted([slot='card-content'].fixed-height) {\n  align-items: center;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  height: inherit;\n  justify-content: center;\n  padding: 0 var(--ids-space-xs);\n  text-align: center;\n  width: 100%;\n}\n \n:host([draggable]) {\n  width: var(--ids-card-width);\n  z-index: 1;\n  transition: var(--ids-motion-duration) var(--ids-motion-ease);\n \n  .ids-card {\n    border: 1px solid var(--ids-card-color-border-draggable);\n    box-shadow: none;\n    height: auto;\n    min-height: auto;\n    cursor: move;\n    overflow-x: hidden;\n \n    .ids-card-header {\n      min-height: 56px;\n \n      slot[name='card-header'] {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n      }\n    }\n \n    &:hover {\n      background-color: var(--ids-card-color-background-hover);\n      color: var(--ids-card-color-text-hover);\n \n      .ids-card-header {\n        slot[name='card-header'] {\n          color: var(--ids-card-color-text-hover);\n        }\n      }\n    }\n \n    &.is-overlapping {\n      cursor: no-drop;\n    }\n \n    &.is-dropped {\n      z-index: 99;\n      width: var(--ids-card-width-dropped, var(--ids-card-width));\n      height: var(--ids-card-height-dropped, 'auto');\n      background-color: var(--ids-card-color-background-dropped, #F5F5F5);\n      opacity: 0.8;\n \n      .ids-card-header {\n        slot[name='card-header'] {\n          color: var(--ids-card-color-text-default);\n        }\n      }\n    }\n \n    &.is-dragging {\n      z-index: 999;\n      width: var(--ids-card-width-dragged, var(--ids-card-width));\n      height: var(--ids-card-height-dragged, 'auto');\n      background-color: var(--ids-card-color-background-dragged, #F5F5F5);\n      opacity: 0.8;\n \n      .ids-card-header {\n        slot[name='card-header'] {\n          color: var(--ids-card-color-text-default);\n        }\n      }\n    }\n \n    &.is-fixed {\n      &.is-dropped, &.is-dragging {\n        position: absolute;\n        justify-content: center;\n \n        .ids-card-header {\n          justify-content: center;\n          align-items: center;\n        }\n      }\n    }\n  }\n}\n \n:host([draggable][is-dragging]) {\n  z-index: 99;\n  transition: none;\n}\n \n:host([draggable][dropped]) {\n  z-index: 9;\n  transition: none;\n}\n \n:host([disabled]) {\n  .ids-card {\n    pointer-events: none;\n    opacity: 0.5;\n  }\n}\n \n:host([actionable][height]) .ids-card {\n  ids-hyperlink {\n    height: inherit;\n  }\n \n  ids-hyperlink::part(link) {\n    height: inherit;\n  }\n \n  ids-button {\n    height: inherit;\n  }\n \n  ids-button::part(button) {\n    height: inherit;\n  }\n}\n "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
